const initialState = {
    //country state city port
    loadingFFSICountry: false,
    FFSICountry: [],
    FFSICountryError: "",
    loadingFFSIState: false,
    FFSIState: [],
    FFSIStateError: "",
    loadingFFSICity: false,
    FFSICity: [],
    FFSICityError: "",
    loadingFFSISeaport: false,
    FFSISeaport: [],
    FFSISeaportError: "",



    //job order info 
    loadingFFQueryDetail: false,
    FFQueryDetailError: "",
    FFQueryDetail: {},
    //job order List 
    loadingFFSeaImpJobOrderList: false,
    FFSeaImpJobOrderListError: "",
    FFSeaImpJobOrderList: [],

    //currency List 
    loadingFFSeaImpCurrencyList: false,
    FFSeaImpCurrencyListError: "",
    FFSeaImpCurrencyList: [],

    //final Quotation
    loadingFFSeaImpFinalQuotationList: false,
    FFSeaImpFinalQuotationListError: "",
    FFSeaImpFinalQuotationList: [],

    //currency List 
    loadingFFSeaImpAirportList: false,
    FFSeaImpAirportListError: "",
    FFSeaImpAirportList: [],


    //organisation list
    loadingFFSeaImpOrganisationList: false,
    FFSeaImpOrganisationList: [],
    FFSeaImpOrganisationListError: '',

    //organisation shipper branch list
    loadingFFSeaImpShipperBranchList: false,
    FFSeaImpShipperBranchList: [],
    FFSeaImpShipperBranchListError: '',

    //organisation consignee branch list
    loadingFFSeaImpConsigneeBranchList: false,
    FFSeaImpConsigneeBranchList: [],
    FFSeaImpConsigneeBranchListError: '',

    //organisatoin shipper branch bank list
    loadingFFSeaImpShipperBranchBankList: false,
    FFSeaImpShipperBranchBankList: [],
    FFSeaImpShipperBranchBankListError: '',

    //organisatoin consignee branch bank list
    loadingFFSeaImpConsigneeBranchBankList: false,
    FFSeaImpConsigneeBranchBankList: [],
    FFSeaImpConsigneeBranchBankListError: '',

    //hawb details
    loadingFFSeaImpHBLDetail: false,
    FFSeaImpHBLDetail: [],
    FFSeaImpHBLDetailError: '',

    //direct mawb details
    loadingFFSeaImpDirectMAWBDetail: false,
    FFSeaImpDirectMAWBDetail: [],
    FFSeaImpDirectMAWBDetailError: '',

    //mawb details
    loadingFFSeaImpMAWBDetail: false,
    FFSeaImpMAWBDetail: [],
    FFSeaImpMAWBDetailError: '',

    //unused hawb list
    loadingFFSeaImpUnusedHBLList: false,
    FFSeaImpUnusedHBLList: [],
    FFSeaImpUnusedHBLListError: '',

    //unused hawb update list
    loadingFFSeaImpUnusedHAWBUpdateList: false,
    FFSeaImpUnusedHAWBUpdateList: [],
    FFSeaImpUnusedHAWBUpdateListError: '',


    //ff-> air-> exp -> console shipment list
    loadingFFSeaImpConsoleShipmentList: false,
    FFSeaImpConsoleShipmentList: [],
    FFSeaImpConsoleShipmentListError: '',
    FFSeaImpConsoleShipmentListCurrentPage: 0,
    FFSeaImpConsoleShipmentListTotalPage: 0,
    FFSeaImpConsoleShipmentListTotalData: 0,
    // FFSeaImpConsoleShipmentListCount: {},

    //ff-> air-> exp -> direct shipment list
    loadingFFSeaImpDirectShipmentList: false,
    FFSeaImpDirectShipmentList: [],
    FFSeaImpDirectShipmentListError: '',
    FFSeaImpDirectShipmentListCurrentPage: 0,
    FFSeaImpDirectShipmentListTotalPage: 0,
    FFSeaImpDirectShipmentListTotalData: 0,
    // FFSeaImpDirectShipmentListCount: {},

    //ff-> air-> exp -> console Manifest list
    loadingFFSeaImpConsoleManifestList: false,
    FFSeaImpConsoleManifestList: [],
    FFSeaImpConsoleManifestListError: '',
    FFSeaImpConsoleManifestListCurrentPage: 0,
    FFSeaImpConsoleManifestListTotalPage: 0,
    FFSeaImpConsoleManifestListTotalData: 0,
    // FFSeaImpConsoleManifestListCount: {},

    //mawb => total freight calculation
    loadingFFSeaImpTotalFreight: false,
    FFSeaImpTotalFreight: {},
    FFSeaImpTotalFreightError: '',

}

const FFSeaImpReducer = (state = initialState, action) => {
    switch (action.type) {

        //country state city port List//
        case 'FIND_FF_SI_COUNTRY_REQUEST':
            return {
                ...state,
                loadingFFSICountry: true,
                FFSICountry: [],
                FFSICountryError: '',
            };
        case 'FIND_FF_SI_COUNTRY_SUCCESS':
            return {
                ...state,
                loadingFFSICountry: false,
                FFSICountry: action.payload,
            };
        case 'FIND_FF_SI_COUNTRY_FAILURE':
            return {
                ...state,
                loadingFFSICountry: false,
                FFSICountryError: action.payload,
            };
        case 'FIND_FF_SI_STATE_REQUEST':
            return {
                ...state,
                loadingFFSIState: true,
                FFSIState: [],
                FFSIStateError: '',
            };
        case 'FIND_FF_SI_STATE_SUCCESS':
            return {
                ...state,
                loadingFFSIState: false,
                FFSIState: action.payload,
            };
        case 'FIND_FF_SI_STATE_FAILURE':
            return {
                ...state,
                loadingFFSIState: false,
                FFSIStateError: action.payload,
            };
        case 'FIND_FF_SI_CITY_REQUEST':
            return {
                ...state,
                loadingFFSICity: true,
                FFSICity: [],
                FFSICityError: '',
            };
        case 'FIND_FF_SI_CITY_SUCCESS':
            return {
                ...state,
                loadingFFSICity: false,
                FFSICity: action.payload,
            };
        case 'FIND_FF_SI_CITY_FAILURE':
            return {
                ...state,
                loadingFFSICity: false,
                FFSICityError: action.payload,
            };
        case 'FIND_FF_SI_SEAPORT_REQUEST':
            return {
                ...state,
                loadingFFSISeaport: true,
                FFSISeaport: [],
                FFSISeaportError: '',
            };
        case 'FIND_FF_SI_SEAPORT_SUCCESS':
            return {
                ...state,
                loadingFFSISeaport: false,
                FFSISeaport: action.payload,
            };
        case 'FIND_FF_SI_SEAPORT_FAILURE':
            return {
                ...state,
                loadingFFSISeaport: false,
                FFSISeaportError: action.payload,
            };
        //country state city port List//

        //query info List//
        case 'FIND_FF_QUERY_INFO_REQUEST':
            return {
                ...state,
                loadingFFQueryDetail: true,
                FFQueryDetail: {},
                FFQueryDetailError: '',
            };
        case 'FIND_FF_QUERY_INFO_SUCCESS':
            return {
                ...state,
                loadingFFQueryDetail: false,
                FFQueryDetail: action.payload,
            };
        case 'FIND_FF_QUERY_INFO_FAILURE':
            return {
                ...state,
                loadingFFQueryDetail: false,
                FFQueryDetailError: action.payload,
            };
        //query info List//

        //job order List//
        case 'FIND_FF_SEA_IMP_JOBORDER_REQUEST':
            return {
                ...state,
                loadingFFSeaImpJobOrderList: true,
                FFSeaImpJobOrderList: [],
                FFSeaImpJobOrderListError: '',
            };
        case 'FIND_FF_SEA_IMP_JOBORDER_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpJobOrderList: false,
                FFSeaImpJobOrderList: action.payload,
            };
        case 'FIND_FF_SEA_IMP_JOBORDER_FAILURE':
            return {
                ...state,
                loadingFFSeaImpJobOrderList: false,
                FFSeaImpJobOrderListError: action.payload,
            };
        //job order List//

        //currency List//
        case 'FIND_FF_SEA_IMP_CURRENCY_REQUEST':
            return {
                ...state,
                loadingFFSeaImpCurrencyList: true,
                FFSeaImpCurrencyList: [],
                FFSeaImpCurrencyListError: '',
            };
        case 'FIND_FF_SEA_IMP_CURRENCY_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpCurrencyList: false,
                FFSeaImpCurrencyList: action.payload,
            };
        case 'FIND_FF_SEA_IMP_CURRENCY_FAILURE':
            return {
                ...state,
                loadingFFSeaImpCurrencyList: false,
                FFSeaImpCurrencyListError: action.payload,
            };
        //currency List//

        //final Quotation List//
        case 'FIND_FF_SEA_IMP_FINAL_QUOTATION_REQUEST':
            return {
                ...state,
                loadingFFSeaImpFinalQuotationList: true,
                FFSeaImpFinalQuotationList: [],
                FFSeaImpFinalQuotationListError: '',
            };
        case 'FIND_FF_SEA_IMP_FINAL_QUOTATION_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpFinalQuotationList: false,
                FFSeaImpFinalQuotationList: action.payload,
            };
        case 'FIND_FF_SEA_IMP_FINAL_QUOTATION_FAILURE':
            return {
                ...state,
                loadingFFSeaImpFinalQuotationList: false,
                FFSeaImpFinalQuotationListError: action.payload,
            };
        //final Quotation List//

        //airport List//
        case 'FIND_FF_SEA_IMP_AIRPORT_REQUEST':
            return {
                ...state,
                loadingFFSeaImpAirportList: true,
                FFSeaImpAirportList: [],
                FFSeaImpAirportListError: '',
            };
        case 'FIND_FF_SEA_IMP_AIRPORT_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpAirportList: false,
                FFSeaImpAirportList: action.payload,
            };
        case 'FIND_FF_SEA_IMP_AIRPORT_FAILURE':
            return {
                ...state,
                loadingFFSeaImpAirportList: false,
                FFSeaImpAirportListError: action.payload,
            };
        //airport List//

        //hawb detail//
        case 'FIND_FF_SEA_IMP_HAWB_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFSeaImpHBLDetail: true,
                FFSeaImpHBLDetail: [],
                FFSeaImpHBLDetailError: '',
            };
        case 'FIND_FF_SEA_IMP_HAWB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpHBLDetail: false,
                FFSeaImpHBLDetail: action.payload,
            };
        case 'FIND_FF_SEA_IMP_HAWB_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFSeaImpHBLDetail: false,
                FFSeaImpHBLDetailError: action.payload,
            };
        //hawb detail//

        //direct mawb detail//
        case 'FIND_FF_SEA_IMP_DIRECT_MAWB_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFSeaImpDirectMAWBDetail: true,
                FFSeaImpDirectMAWBDetail: [],
                FFSeaImpDirectMAWBDetailError: '',
            };
        case 'FIND_FF_SEA_IMP_DIRECT_MAWB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpDirectMAWBDetail: false,
                FFSeaImpDirectMAWBDetail: action.payload,
            };
        case 'FIND_FF_SEA_IMP_DIRECT_MAWB_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFSeaImpDirectMAWBDetail: false,
                FFSeaImpDirectMAWBDetailError: action.payload,
            };
        //direct mawb detail//

        //mawb detail//
        case 'FIND_FF_SEA_IMP_MAWB_DETAIL_REQUEST':
            return {
                ...state,
                loadingFFSeaImpMAWBDetail: true,
                FFSeaImpMAWBDetail: [],
                FFSeaImpMAWBDetailError: '',
            };
        case 'FIND_FF_SEA_IMP_MAWB_DETAIL_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpMAWBDetail: false,
                FFSeaImpMAWBDetail: action.payload,
            };
        case 'FIND_FF_SEA_IMP_MAWB_DETAIL_FAILURE':
            return {
                ...state,
                loadingFFSeaImpMAWBDetail: false,
                FFSeaImpMAWBDetailError: action.payload,
            };
        //mawb detail//

        //organisation List//
        case 'FIND_FF_SEA_IMP_ORGANISATION_REQUEST':
            return {
                ...state,
                loadingFFSeaImpOrganisationList: true,
                FFSeaImpOrganisationList: [],
                FFSeaImpOrganisationListError: '',
            };
        case 'FIND_FF_SEA_IMP_ORGANISATION_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpOrganisationList: false,
                FFSeaImpOrganisationList: action.payload,
            };
        case 'FIND_FF_SEA_IMP_ORGANISATION_FAILURE':
            return {
                ...state,
                loadingFFSeaImpOrganisationList: false,
                FFSeaImpOrganisationListError: action.payload,
            };
        //organisation List//

        //organisation shipper branch List//
        case 'FIND_FF_SEA_IMP_SHIPPER_BRANCH_REQUEST':
            return {
                ...state,
                loadingFFSeaImpShipperBranchList: true,
                FFSeaImpShipperBranchList: [],
                FFSeaImpShipperBranchListError: '',
            };
        case 'FIND_FF_SEA_IMP_SHIPPER_BRANCH_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpShipperBranchList: false,
                FFSeaImpShipperBranchList: action.payload,
            };
        case 'FIND_FF_SEA_IMP_SHIPPER_BRANCH_FAILURE':
            return {
                ...state,
                loadingFFSeaImpShipperBranchList: false,
                FFSeaImpShipperBranchListError: action.payload,
            };
        //organisation shipper branch List//

        //organisation consignee branch List//
        case 'FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_REQUEST':
            return {
                ...state,
                loadingFFSeaImpConsigneeBranchList: true,
                FFSeaImpConsigneeBranchList: [],
                FFSeaImpConsigneeBranchListError: '',
            };
        case 'FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpConsigneeBranchList: false,
                FFSeaImpConsigneeBranchList: action.payload,
            };
        case 'FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_FAILURE':
            return {
                ...state,
                loadingFFSeaImpConsigneeBranchList: false,
                FFSeaImpConsigneeBranchListError: action.payload,
            };
        //organisation consignee branch List//

        //organisation shipper branch bank List//
        case 'FIND_FF_SEA_IMP_SHIPPER_BRANCH_BANK_REQUEST':
            return {
                ...state,
                loadingFFSeaImpShipperBranchBankList: true,
                FFSeaImpShipperBranchBankList: [],
                FFSeaImpShipperBranchBankListError: '',
            };
        case 'FIND_FF_SEA_IMP_SHIPPER_BRANCH_BANK_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpShipperBranchBankList: false,
                FFSeaImpShipperBranchBankList: action.payload,
            };
        case 'FIND_FF_SEA_IMP_SHIPPER_BRANCH_BANK_FAILURE':
            return {
                ...state,
                loadingFFSeaImpShipperBranchBankList: false,
                FFSeaImpShipperBranchBankListError: action.payload,
            };
        //organisation shipper branch bank List//

        //organisation consignee branch bank List//
        case 'FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_BANK_REQUEST':
            return {
                ...state,
                loadingFFSeaImpConsigneeBranchBankList: true,
                FFSeaImpConsigneeBranchBankList: [],
                FFSeaImpConsigneeBranchBankListError: '',
            };
        case 'FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_BANK_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpConsigneeBranchBankList: false,
                FFSeaImpConsigneeBranchBankList: action.payload,
            };
        case 'FIND_FF_SEA_IMP_CONSIGNEE_BRANCH_BANK_FAILURE':
            return {
                ...state,
                loadingFFSeaImpConsigneeBranchBankList: false,
                FFSeaImpConsigneeBranchBankListError: action.payload,
            };
        //organisation consignee branch bank List//

        //mawb-> unused hawb list//
        case 'FIND_FF_SEA_IMP_UNUSED_HAWB_REQUEST':
            return {
                ...state,
                loadingFFSeaImpUnusedHBLList: true,
                FFSeaImpUnusedHBLList: [],
                FFSeaImpUnusedHBLListError: '',
            };
        case 'FIND_FF_SEA_IMP_UNUSED_HAWB_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpUnusedHBLList: false,
                FFSeaImpUnusedHBLList: action.payload,
            };
        case 'FIND_FF_SEA_IMP_UNUSED_HAWB_FAILURE':
            return {
                ...state,
                loadingFFSeaImpUnusedHBLList: false,
                FFSeaImpUnusedHBLListError: action.payload,
            };
        //mawb-> unused hawb list//

        //mawb-> unused hawb update list//
        case 'FIND_FF_SEA_IMP_UNUSED_HAWB_UPDATE_REQUEST':
            return {
                ...state,
                loadingFFSeaImpUnusedHAWBUpdateList: true,
                FFSeaImpUnusedHAWBUpdateList: [],
                FFSeaImpUnusedHAWBUpdateListError: '',
            };
        case 'FIND_FF_SEA_IMP_UNUSED_HAWB_UPDATE_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpUnusedHAWBUpdateList: false,
                FFSeaImpUnusedHAWBUpdateList: action.payload,
            };
        case 'FIND_FF_SEA_IMP_UNUSED_HAWB_UPDATE_FAILURE':
            return {
                ...state,
                loadingFFSeaImpUnusedHAWBUpdateList: false,
                FFSeaImpUnusedHAWBUpdateListError: action.payload,
            };
        //mawb-> unused hawb update list//

        //mawb-> unused mawb in console manifest add form//
        case 'FIND_FF_SEA_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_REQUEST':
            return {
                ...state,
                loadingFFSeaImpUnusedConsoleManifestMBLAddList: true,
                FFSeaImpUnusedConsoleManifestMBLAddList: [],
                FFSeaImpUnusedConsoleManifestMBLAddListError: '',
            };
        case 'FIND_FF_SEA_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpUnusedConsoleManifestMBLAddList: false,
                FFSeaImpUnusedConsoleManifestMBLAddList: action.payload,
            };
        case 'FIND_FF_SEA_IMP_CONSOLE_MANIFEST_MAWB_ADD_LIST_FAILURE':
            return {
                ...state,
                loadingFFSeaImpUnusedConsoleManifestMBLAddList: false,
                FFSeaImpUnusedConsoleManifestMBLAddListError: action.payload,
            };
        //mawb-> unused mawb in console manifest add form//

        //mawb-> calculate total freight//
        case 'FIND_CALCULATE_TOTAL_FREIGHT_REQUEST':
            return {
                ...state,
                loadingFFSeaImpTotalFreight: true,
                FFSeaImpTotalFreight: {},
                FFSeaImpTotalFreightError: '',
            };
        case 'FIND_CALCULATE_TOTAL_FREIGHT_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpTotalFreight: false,
                FFSeaImpTotalFreight: action.payload,
            };
        case 'FIND_CALCULATE_TOTAL_FREIGHT_FAILURE':
            return {
                ...state,
                loadingFFSeaImpTotalFreight: false,
                FFSeaImpTotalFreightError: action.payload,
            };
        //mawb-> calculate total freight//

        //ff -> air -> exp -> console shipment list//
        case 'FIND_FF_SEA_IMP_CONSOLE_SHIPMENT_LIST_REQUEST':
            return {
                ...state,
                loadingFFSeaImpConsoleShipmentList: true,
                FFSeaImpConsoleShipmentList: [],
                FFSeaImpConsoleShipmentListError: '',
                FFSeaImpConsoleShipmentListCurrentPage: 0,
                FFSeaImpConsoleShipmentListTotalPage: 0,
                FFSeaImpConsoleShipmentListTotalData: 0,
                // FFSeaImpConsoleShipmentListCount: {},
            };
        case 'FIND_FF_SEA_IMP_CONSOLE_SHIPMENT_LIST_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpConsoleShipmentList: false,
                FFSeaImpConsoleShipmentList: action.payload.data,
                FFSeaImpConsoleShipmentListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFSeaImpConsoleShipmentListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFSeaImpConsoleShipmentListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFSeaImpConsoleShipmentListCount: {},
            };
        case 'FIND_FF_SEA_IMP_CONSOLE_SHIPMENT_LIST_FAILURE':
            return {
                ...state,
                loadingFFSeaImpConsoleShipmentList: true,
                FFSeaImpConsoleShipmentListError: '',
                FFSeaImpConsoleShipmentListCurrentPage: 1,
                FFSeaImpConsoleShipmentListTotalPage: 0,
                FFSeaImpConsoleShipmentListTotalData: 0,
                // FFSeaImpConsoleShipmentListCount: {},
            };
        //ff -> air -> exp -> console shipment list//

        //ff -> air -> exp -> direct shipment list//
        case 'FIND_FF_SEA_IMP_DIRECT_SHIPMENT_LIST_REQUEST':
            return {
                ...state,
                loadingFFSeaImpDirectShipmentList: true,
                FFSeaImpDirectShipmentList: [],
                FFSeaImpDirectShipmentListError: '',
                FFSeaImpDirectShipmentListCurrentPage: 0,
                FFSeaImpDirectShipmentListTotalPage: 0,
                FFSeaImpDirectShipmentListTotalData: 0,
                // FFSeaImpDirectShipmentListCount: {},
            };
        case 'FIND_FF_SEA_IMP_DIRECT_SHIPMENT_LIST_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpDirectShipmentList: false,
                FFSeaImpDirectShipmentList: action.payload.data,
                FFSeaImpDirectShipmentListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFSeaImpDirectShipmentListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFSeaImpDirectShipmentListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFSeaImpDirectShipmentListCount: {},
            };
        case 'FIND_FF_SEA_IMP_DIRECT_SHIPMENT_LIST_FAILURE':
            return {
                ...state,
                loadingFFSeaImpDirectShipmentList: true,
                FFSeaImpDirectShipmentListError: '',
                FFSeaImpDirectShipmentListCurrentPage: 1,
                FFSeaImpDirectShipmentListTotalPage: 0,
                FFSeaImpDirectShipmentListTotalData: 0,
                // FFSeaImpDirectShipmentListCount: {},
            };
        //ff -> air -> exp -> direct shipment list//

        //ff -> air -> exp -> console manifest list//
        case 'FIND_FF_SEA_IMP_CONSOLE_MANIFEST_LIST_REQUEST':
            return {
                ...state,
                loadingFFSeaImpConsoleManifestList: true,
                FFSeaImpConsoleManifestList: [],
                FFSeaImpConsoleManifestListError: '',
                FFSeaImpConsoleManifestListCurrentPage: 0,
                FFSeaImpConsoleManifestListTotalPage: 0,
                FFSeaImpConsoleManifestListTotalData: 0,
                // FFSeaImpConsoleManifestListCount: {},
            };
        case 'FIND_FF_SEA_IMP_CONSOLE_MANIFEST_LIST_SUCCESS':
            return {
                ...state,
                loadingFFSeaImpConsoleManifestList: false,
                FFSeaImpConsoleManifestList: action.payload.data,
                FFSeaImpConsoleManifestListCurrentPage: action.payload.pagination ? action.payload.pagination.currentPage : 1,
                FFSeaImpConsoleManifestListTotalPage: action.payload.pagination ? action.payload.pagination.totalPages : 0,
                FFSeaImpConsoleManifestListTotalData: action.payload.pagination ? action.payload.pagination.totalRecords : 0,
                // FFSeaImpConsoleManifestListCount: {},
            };
        case 'FIND_FF_SEA_IMP_CONSOLE_MANIFEST_LIST_FAILURE':
            return {
                ...state,
                loadingFFSeaImpConsoleManifestList: true,
                FFSeaImpConsoleManifestListError: '',
                FFSeaImpConsoleManifestListCurrentPage: 1,
                FFSeaImpConsoleManifestListTotalPage: 0,
                FFSeaImpConsoleManifestListTotalData: 0,
                // FFSeaImpConsoleManifestListCount: {},
            };
        //ff -> air -> exp -> console manifest list//

        default:
            return state;
    }
}

export default FFSeaImpReducer;